namespace $ {
	
	export function $shm_hitalama_is_panning( start: PointerEvent, end: PointerEvent ) {

		if( end.timeStamp - start?.timeStamp > 500
			|| Math.abs(end.x - start?.x) > 10
			|| Math.abs(end.y - start?.y) > 10
		) return true

		return false

	}

	export function $shm_hitalama_is_input( el: Element ) {
		if( ['INPUT', 'TEXTAREA', 'SELECT'].includes( el.nodeName ) ) return true
		if( el instanceof HTMLElement && el.isContentEditable ) return true
		return Boolean( el.closest( 'input, textarea, select, [contenteditable="true"], [contenteditable="plaintext-only"]' ) )
	}

	export function $shm_hitalama_is_input_focused() {
		const focused = $mol_view_selection.focused()[0]
		if( focused && $shm_hitalama_is_input( focused ) ) return true

		const active = $mol_dom_context.document.activeElement
		return active instanceof Element && $shm_hitalama_is_input( active )
	}

}
